<template>
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
  >
    <path
      d="M10.4714 5.80466C10.7317 5.54431 10.7317 5.1222 10.4714 4.86185C10.211 4.6015 9.7889 4.6015 9.52855 4.86185L7.33329 7.05711L6.47136 6.19518C6.21101 5.93483 5.7889 5.93483 5.52855 6.19518C5.26821 6.45553 5.26821 6.87764 5.52855 7.13799L6.86189 8.47132C7.12224 8.73167 7.54435 8.73167 7.8047 8.47132L10.4714 5.80466Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.3333 11.9999H8.66663V13.3333H10.6666C11.0348 13.3333 11.3333 13.6317 11.3333 13.9999C11.3333 14.3681 11.0348 14.6666 10.6666 14.6666H5.33329C4.9651 14.6666 4.66663 14.3681 4.66663 13.9999C4.66663 13.6317 4.9651 13.3333 5.33329 13.3333H7.33329V11.9999H2.66663C1.56206 11.9999 0.666626 11.1045 0.666626 9.99992V3.33325C0.666626 2.22868 1.56206 1.33325 2.66663 1.33325H13.3333C14.4379 1.33325 15.3333 2.22868 15.3333 3.33325V9.99992C15.3333 11.1045 14.4379 11.9999 13.3333 11.9999ZM1.99996 3.33325C1.99996 2.96506 2.29844 2.66659 2.66663 2.66659H13.3333C13.7015 2.66659 14 2.96506 14 3.33325V9.99992C14 10.3681 13.7015 10.6666 13.3333 10.6666H2.66663C2.29844 10.6666 1.99996 10.3681 1.99996 9.99992V3.33325Z"
    />
  </svg>
</template>
